<script setup>
import { CreditCard, CheckCircle2, Clock, CircleDollarSign } from 'lucide-vue-next'
import Card from './Card.vue'
import CtaButton from './CtaButton.vue'
import { paymentVariant } from '../lib/status'

defineProps({
  payments: { type: Array, required: true },
})

// Ícone da linha por variante de pagamento.
const rowIcon = {
  success: { component: CheckCircle2, class: 'text-white bg-up-green' },
  warning: { component: Clock, class: 'text-up-navy bg-slate-100' },
  muted: { component: CircleDollarSign, class: 'text-up-gray bg-slate-100' },
}
</script>

<template>
  <Card title="Pagamentos" :icon="CreditCard" link-label="Ver detalhes" link-href="/pagamentos">
    <p v-if="!payments.length" class="rounded-lg border border-slate-100 px-4 py-6 text-center text-sm text-slate-500">
      Nenhuma parcela lançada ainda.
    </p>

    <ul v-else class="divide-y divide-slate-100 overflow-hidden rounded-lg border border-slate-100">
      <li v-for="item in payments" :key="item.label" class="flex items-center gap-3 px-4 py-4">
        <span
          class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full"
          :class="(rowIcon[item.variant] || rowIcon.muted).class"
          aria-hidden="true"
        >
          <component :is="(rowIcon[item.variant] || rowIcon.muted).component" class="h-5 w-5" />
        </span>
        <span class="font-semibold text-up-navy">{{ item.label }}</span>
        <span
          class="ml-auto shrink-0 rounded-md px-3 py-1.5 text-xs font-medium"
          :class="paymentVariant(item.variant)"
        >
          {{ item.status }}
        </span>
      </li>
    </ul>

    <div class="mt-auto pt-5">
      <CtaButton href="/pagamentos" variant="outline">Ver pagamentos</CtaButton>
    </div>
  </Card>
</template>
